import { gql } from '@apollo/client'

const GET_TEMPLATE_LIBRARY = gql`
  query getTemplateLibrary {
    getTemplateLibrary {
      id
      appcuesFlowId
      createdAt
      updatedAt
      archivedAt
      showInListing
      description
      checklistItemTemplate {
        id
        title
        resourceId
        displayOrder
        linkText
        linkUrl
        templateLibraryId
        createdAt
        updatedAt
      }
      goalTemplate {
        id
        title
        category
      }
    }
  }
`

export default GET_TEMPLATE_LIBRARY
